export function registerSW() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw-video.js')
        .then((reg) => {
          console.log('SW registrado:', reg);
        })
        .catch((err) => {
          console.error('Error al registrar SW', err);
        });
    });
  }
}


export async function warmCache(urls = []) {
  if (!('serviceWorker' in navigator)) return;
  const post = () =>
    navigator.serviceWorker.controller?.postMessage({ type: 'CACHE_PLAYLIST', urls });
  if (navigator.serviceWorker.controller) post();
  else {
    await navigator.serviceWorker.ready;
    post();
  }
}
